import React from "react";
import { Paper, Typography, Container } from "@mui/material";
import { styled } from "@mui/material/styles";

const useStyles = styled((theme) => ({
  receiptPaper: {
    position: "relative",
    padding: theme.spacing(2),
    border: "1px solid #000",
    marginBottom: theme.spacing(2),
  },
  tornPaper: {
    position: "absolute",
    bottom: "0",
    left: "0",
    width: "100%",
    height: "50px", // Adjust the height as needed for your torn paper image
    background: `url('/path/to/torn-paper-image.png')`,
    backgroundSize: "cover",
  },
  header: {
    marginBottom: theme.spacing(2),
  },
  // Add more styles as needed for your receipt content
}));

const Receipt = () => {
  const classes = useStyles();

  return (
    <Container>
      <Paper className={classes.receiptPaper}>
        <Typography variant="h4" className={classes.header}>
          Receipt
        </Typography>
        {/* Add your receipt content here */}
        <Typography>Item 1: $100</Typography>
        <Typography>Item 2: $20</Typography>
        {/* Add more content as needed */}
      </Paper>
      <div className={classes.tornPaper} />
    </Container>
  );
};

export default Receipt;
